import { useState, useEffect } from "react";
import { Clock, AlertTriangle, Check, Upload, Eye, AlertCircle, ArrowRight, BarChart2, ArrowDownLeft, ArrowUpRight, CheckCircle } from "lucide-react";
import { Button, Chip, Avatar, Paper, Box, Typography } from "@mui/material";
import WrapUpP2p from "./layouts/WrapUpP2p";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { exchangeActions, peerActions } from "../../../redux/actions";
import { allRemoteSettingsSelect, exchangeSelect, peerSelect, userSelect } from "../../../redux/selectors";
import { formatDateTime, guessAdminRoute, money, notify } from "../../../utility/Helper1";
import Countdown from "react-countdown";
import ImagePopup from "./ImagePopup";
import MarketProgressBar from "./MarketProgressBar";



// Main P2P Order Component
const P2POrderDisplay = () => {

    // Sample data based on your PHP code
    const site_settings = useSelector(allRemoteSettingsSelect);
    const settings = site_settings?.operational_settings;

    const [targetDate, setTargetDate] = useState(new Date(Date.now() + 2 * 60 * 1000))
    const [resetKey, setResetKey] = useState(0)
    const [marketLoading, setMarketLoading] = useState(false)
    

    const peerRoot = useSelector(peerSelect);
    const exchangeRoot = useSelector(exchangeSelect);
    const peerData = peerRoot?.filter(el => !['BLOCKED', 'PAID'].includes(el.status));

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const userData = useSelector(userSelect);




    const onLoadPeer = () => {

        dispatch(peerActions.onGet("p2p/load/peer", response => {

        }))

    }


  const onLoadPH = () => {

    dispatch(exchangeActions.onGetExchange("p2p/load/all", response => {

    }))

  }

  

    useEffect(() => {
        onLoadPeer()
        onLoadPH()
    }, [])



    // Current user ID (for demonstration)
    const currentUserAccountId = userData?.accountId;

    // State for active tab
    const [activeTab, setActiveTab] = useState("all");
    const [uploadingProof, setUploadingProof] = useState(false);
    const [reportingProof, setReportingProof] = useState(false);
    const [confirmingProof, setConfirmingProof] = useState(false);

    const [focusedPeer, setFocusedPeer] = useState(null);

    const incomingPayments = peerData?.filter(order => order?.gherAccountId == currentUserAccountId)
    const outgoingPayments = peerData?.filter(order => order?.pherAccountId == currentUserAccountId)
    const completedPayments = peerRoot?.filter(order => order?.status == 'PAID')


    // Filter orders based on active tab
    let filteredOrders = activeTab == "all"
        ? (peerData ?? [])
        : activeTab === "incoming"
            ? incomingPayments
            : outgoingPayments;

    if (activeTab === "completed") {
        filteredOrders = completedPayments;
    }

    // Handle file selection and upload
    const handleFileUpload = (orderId) => {
        document.getElementById(`file-${orderId}`).click();
    };

    const handleFileChange = (e, orderId) => {

        setUploadingProof(true)

        if (e.target.files && e.target.files[0]) {
            // // In a real app, you would handle the file upload here
            // console.log(`File selected for order ${orderId}:`, e.target.files[0].name);

            const file = e.target.files[0];
            dispatch(peerActions.onPost({ image: file }, `p2p/payment/upload/${orderId}`, response => {
                setUploadingProof(false)
                notify(response.msg, response.code)
            }),
            )

        }
    };


    const reportTransaction = (orderId) => {

        setReportingProof(true)

        dispatch(peerActions.onGet(`p2p/payment/report/${orderId}`, response => {
            setReportingProof(false)
            notify(response.msg, response.code)
        }),
        )

    };



    // Handle marking as paid
    const handleMarkAsPaid = (orderId) => {
        setConfirmingProof(true)

        dispatch(peerActions.onPost({paid: 1}, `p2p/payment/confirm/${orderId}`, response => {
            setConfirmingProof(false)
            notify(response.msg, response.code)
        }),
        )
    };


    const handleReset = () => {
        setTargetDate(new Date(Date.now() + 2 * 60 * 1000))
        setResetKey((prev) => prev + 1)
    }

    const handleGoToMarket = () => { //async

        const allAccountPH = exchangeRoot?.reduce((sum, item) => sum + (Number(item.ph) || 0), 0);
        if(allAccountPH <= 0){
            notify('You dont have any peerable investment. Please add an investment.', 0)
            return;
        }
        if(marketLoading){ 
            notify('You have an active ongoing request.', 0)
            return;
         }
       
        setMarketLoading(true)


        // const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
        // // Wait for 3 seconds
        // await delay(3000);

        
        dispatch(peerActions.onPost({loadMarket: true}, `p2p/market/time`, response => {

            if (response?.code == 1) {
                notify('Bid successful', 1)
              } else {
                notify('Market is still opened. Please try again', 0)
              }

            setMarketLoading(false)
        }),
        )

    }

    const handleAdd = () => {
        navigate('/projects/new')
    }


    const tabs = [
        { id: "all", label: "All Actives", count: peerData?.length ?? 0, icon: <BarChart2 className="w-4 h-4" /> },
        { id: "incoming", label: "Incoming", count: incomingPayments?.length ?? 0, icon: <ArrowDownLeft className="w-4 h-4" /> },
        { id: "outgoing", label: "Outgoing", count: outgoingPayments?.length ?? 0, icon: <ArrowUpRight className="w-4 h-4" /> },
        { id: "completed", label: "Completed", count: completedPayments?.length ?? 0, icon: <CheckCircle className="w-4 h-4" /> },
    ];
console.log('settings?.site_settings?.timezone', site_settings?.site_settings?.timezone)

    return (<WrapUpP2p>


        {settings?.p2p_use_time_based_peering == 1 && <div className="bg-gray-50 p-6 flex flex-col">
            <div className="max-w-6xl w-full mx-auto mb-8">
                <MarketProgressBar timezone={site_settings?.site_settings?.timezone} key={resetKey} closingTime={new Date(settings?.p2p_markettimeEnds)} targetDate={new Date(settings?.p2p_markettimeStart)} 
                    onGoToMarket={handleGoToMarket} 
                    marketLoading={marketLoading}
                    onAdd={handleAdd} />
            </div>
        </div>}


        <div className="bg-gray-50 min-h-screen p-6">
            <div className="max-w-6xl mx-auto">
                {/* Header with tabs */}


                <div className="bg-gray-50 rounded-xl max-w-full">
                    <h1 className="text-2xl font-bold text-gray-800 mb-4">
                        Market Orders
                    </h1>

                    {/* Desktop Tabs */}
                    <div className="hidden md:flex flex-wrap gap-2 mb-6">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-2 px-4 py-2 rounded-md font-medium text-sm transition-all ${activeTab === tab.id
                                        ? "bg-green-500 text-white shadow-sm"
                                        : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
                                    }`}
                            >
                                {tab.icon}
                                <span>{tab.label}</span>
                                <span className="bg-opacity-20 bg-gray-700 text-xs px-2 py-0.5 rounded-full ml-1">
                                    {tab.count}
                                </span>
                            </button>
                        ))}
                    </div>

                    {/* Mobile Tabs - Scrollable */}
                    <div className="md:hidden overflow-x-auto pb-2 mb-4">
                        <div className="flex space-x-2 min-w-max">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`flex items-center gap-1 px-3 py-2 rounded-md font-medium text-sm transition-all ${activeTab === tab.id
                                            ? "bg-green-500 text-white shadow-sm"
                                            : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
                                        }`}
                                >
                                    {tab.icon}
                                    <span className="whitespace-nowrap">{tab.label}</span>
                                    <span className="bg-opacity-20 bg-gray-700 text-xs px-1.5 rounded-full">
                                        {tab.count}
                                    </span>
                                </button>
                            ))}
                        </div>
                    </div>

                </div>

                {/* Statistics Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    {/* <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                        <div className="flex items-center mb-2">
                            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3">
                                <Check className="text-green-500" size={20} />
                            </div>
                            <span className="text-gray-600 font-medium">Completed</span>
                        </div>
                        <div className="text-3xl font-bold text-gray-800">
                            {peerData.filter(order => order?.status == "PAID").length}
                        </div>
                    </div> */}

                    <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                        <div className="flex items-center mb-2">
                            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center mr-3">
                                <Clock className="text-yellow-500" size={20} />
                            </div>
                            <span className="text-gray-600 font-medium">Pending</span>
                        </div>
                        <div className="text-3xl font-bold text-gray-800">
                            {peerData?.filter(order => ["NO", "YES", "REJECTED"].includes(order?.status)).length}
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                        <div className="flex items-center mb-2">
                            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3">
                                <AlertTriangle className="text-red-500" size={20} />
                            </div>
                            <span className="text-gray-600 font-medium">Reported</span>
                        </div>
                        <div className="text-3xl font-bold text-gray-800">
                            {peerData?.filter(order => order?.reported == "1").length}
                        </div>
                    </div>
                </div>

                {/* Order Cards */}
                {filteredOrders.length > 0 ? (
                    <div className="space-y-6">
                        {filteredOrders.map((order) => {
                            const isPayer = order?.pherAccountId === currentUserAccountId;
                            const isReceiver = order?.gherAccountId === currentUserAccountId;
                            const blockingtimer = Number(order?.timestamp) + (60 * 60 * Number(order?.paywindow));

                            return (
                                <div key={order?.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                                    {/* Card Header */}
                                    <div className="bg-gradient-to-r from-green-600 to-green-500 px-6 py-4 flex justify-between items-center">
                                        <div>
                                            <div className="flex items-center">
                                                <span className="text-white font-medium text-lg">
                                                    Order
                                                </span>
                                                <Chip
                                                    label={order?.status == "PAID" ? "Completed" : "Pending"}
                                                    size="small"
                                                    color={order?.status == "PAID" ? "success" : "warning"}
                                                    className="ml-3"
                                                />
                                            </div>
                                            <p className="text-green-50 text-sm">
                                                {formatDateTime(Number(order?.timestamp))}
                                            </p>
                                        </div>
                                        <div className="text-right">
                                            <span className="text-white font-bold text-2xl">
                                                {money(order?.donate, order?.motherType)}
                                            </span>
                                            <p className="text-green-50 text-sm">
                                                {order?.autoConfirm == 1 ? "Crypto" : "Fiat"} {order?.transid}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Card Body */}
                                    <div className="px-6 py-4">
                                        {/* Transaction Flow */}
                                        <div className="flex items-center justify-between mb-6 bg-gray-50 p-4 rounded-lg">
                                            {/* PHer (Payer) Side */}
                                            <div className="text-center">
                                                <Avatar src={`${guessAdminRoute()}/assets/uploads/avatar/${order?.pherImage}`} className="mx-auto mb-2 bg-green-600">
                                                    {order?.pherFirstname?.[0]}{order?.pherSurname?.[0]}
                                                </Avatar>
                                                <div className="font-medium text-gray-800">
                                                    {order?.pherFirstname} {order?.pherSurname}
                                                </div>
                                                <div className="text-sm text-gray-500">
                                                    @{order?.pherUsername}
                                                </div>
                                                <Chip
                                                    label="Payer"
                                                    size="small"
                                                    color="primary"
                                                    className="mt-1"
                                                />
                                            </div>

                                            {/* Arrow */}
                                            <div className="flex flex-col items-center">
                                                <ArrowRight className="text-green-500" size={32} />
                                                {/* <div className="text-sm text-gray-500 mt-1">
                                                    {money(order?.donate, order?.motherType)}
                                                </div> */}
                                            </div>

                                            {/* GHer (Receiver) Side */}
                                            <div className="text-center">
                                                <Avatar src={`${guessAdminRoute()}/assets/uploads/avatar/${order?.gherImage}`} className="mx-auto mb-2 bg-green-600">
                                                    {order?.gherFirstname?.[0]}{order?.gherSurname?.[0]}
                                                </Avatar>
                                                <div className="font-medium text-gray-800">
                                                    {order?.gherFirstname} {order?.gherSurname}
                                                </div>
                                                <div className="text-sm text-gray-500">
                                                    @{order?.gherUsername}
                                                </div>
                                                <Chip
                                                    label="Earner"
                                                    size="small"
                                                    color="success"
                                                    className="mt-1"
                                                />
                                            </div>
                                        </div>

                                        {/* Details Grid */}
                                        {!['PAID', 'BLOCKED']?.includes(order.status) && <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            {/* Left Column: Transaction Details */}
                                            <div>
                                                <h3 className="font-semibold text-gray-700 mb-3 pb-2 border-b border-gray-200">
                                                    Transaction Details
                                                </h3>
                                                <div className="space-y-2">
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Amount:</span>
                                                        <span className="font-medium text-gray-800">{money(order?.donate, order?.motherType)}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Type:</span>
                                                        <span className="font-medium text-gray-800">
                                                            {isPayer ? "Outgoing payment" : "Incoming payment"}
                                                        </span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Status:</span>
                                                        <span className={`font-medium ${order?.status == "PAID" ? "text-green-600" : "text-yellow-600"}`}>
                                                            {order?.status == "PAID" ? "Completed" : "Pending"}
                                                        </span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600">Payment Window:</span>
                                                        <span className="font-medium text-gray-800">{order?.paywindow} hours</span>
                                                    </div>

                                                    {/* Countdown Timer (if applicable) */}
                                                    {blockingtimer && (
                                                        <div className="bg-green-50 border border-green-100 rounded-md p-2 mt-2">
                                                            <div className="flex justify-between items-center">
                                                                <span className="text-gray-600">Time Remaining:</span>
                                                                <Countdown
                                                                    date={new Date(Number(blockingtimer) * 1000)}
                                                                    renderer={({ hours, minutes, seconds, completed }) => {
                                                                        if (completed) {
                                                                            return <span>Payment timeout</span>
                                                                        } else {
                                                                            return <span>{hours}H : {minutes}M : {seconds}S</span>;
                                                                        }
                                                                    }}
                                                                />

                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Right Column: Payment Details */}
                                            <div>
                                                <h3 className="font-semibold text-gray-700 mb-3 pb-2 border-b border-gray-200">
                                                    {isPayer ? "Payment Information" : "Payer Information"}
                                                </h3>
                                                <div className="space-y-2">
                                                    {/* For Payer: Show receiver's details */}
                                                    {isPayer && (
                                                        <>
                                                            <div className="flex justify-between">
                                                                <span className="text-gray-600">Recipient:</span>
                                                                <span className="font-medium text-gray-800">
                                                                    {order?.gherFirstname} {order?.gherSurname}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between">
                                                                <span className="text-gray-600">Phone:</span>
                                                                <span className="font-medium text-gray-800">{order?.gherPhone}</span>
                                                            </div>

                                                            {order?.autoConfirm == 1 ? (
                                                                <div className="flex justify-between">
                                                                    <span className="text-gray-600">Wallet Address:</span>
                                                                    <span className="font-medium text-gray-800 text-xs md:text-sm break-all">
                                                                        {order?.[`wallet${order?.motherType}`]}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div className="flex justify-between">
                                                                        <span className="text-gray-600">Bank:</span>
                                                                        <span className="font-medium text-gray-800">{order?.gherBank}</span>
                                                                    </div>
                                                                    <div className="flex justify-between">
                                                                        <span className="text-gray-600">Account Name:</span>
                                                                        <span className="font-medium text-gray-800">{order?.gherAccountname}</span>
                                                                    </div>
                                                                    <div className="flex justify-between">
                                                                        <span className="text-gray-600">Account Number:</span>
                                                                        <span className="font-medium text-gray-800">{order?.gherAccountnumber}</span>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    )}

                                                    {/* For Receiver: Show payer's details */}
                                                    {isReceiver && (
                                                        <>
                                                            <div className="flex justify-between">
                                                                <span className="text-gray-600">Payer:</span>
                                                                <span className="font-medium text-gray-800">
                                                                    {order?.pherFirstname} {order?.pherSurname}
                                                                </span>
                                                            </div>
                                                            <div className="flex justify-between">
                                                                <span className="text-gray-600">Phone:</span>
                                                                <span className="font-medium text-gray-800">{order?.pherPhone}</span>
                                                            </div>
                                                            <div className="flex justify-between">
                                                                <span className="text-gray-600">Username:</span>
                                                                <span className="font-medium text-gray-800">@{order?.pherUsername}</span>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>}

                                        {/* Action Buttons */}
                                        <div className="mt-6 pt-4 border-t border-gray-100">
                                            {isPayer && ['YES', 'NO'].includes(order?.status) && (
                                                <div className="flex flex-wrap gap-2">
                                                    <Button
                                                        disable={uploadingProof}
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={!uploadingProof ? <Upload /> : null}
                                                        className="bg-green-600 hover:bg-green-700"
                                                        onClick={() => handleFileUpload(order?.id)}
                                                    >
                                                        {!uploadingProof && 'Upload Payment Proof'}
                                                        {uploadingProof && <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>}
                                                    </Button>
                                                    <input
                                                        type="file"
                                                        id={`file-${order?.id}`}
                                                        className="hidden"
                                                        onChange={(e) => handleFileChange(e, order?.id)}
                                                        accept="image/*"
                                                    />
                                                </div>
                                            )}

                                            {isPayer && order?.status == "YES" && <div>
                                                Awaiting confirmation
                                            </div>}

                                            {1==1 && ( //isReceiver
                                                <div className="flex flex-wrap gap-2">
                                                    {isReceiver && !['PAID', 'BLOCKED'].includes(order?.status) && (
                                                        <Button
                                                            disable={confirmingProof}
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={!confirmingProof ? <Check /> : null}
                                                            className="bg-green-600 hover:bg-green-700"
                                                            onClick={() => window.confirm("This action cannot be reversed. Click OK to confirm this transaction!") && handleMarkAsPaid(order?.id)}
                                                        >
                                                            {!confirmingProof && 'Confirm'}
                                                            {confirmingProof && <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>}

                                                        </Button>
                                                    )}

                                                    {isReceiver && order?.status == "YES" && order?.reported == 0 && (
                                                        <Button
                                                            disable={reportingProof}
                                                            variant="outlined"
                                                            color="error"
                                                            startIcon={!reportingProof ? <AlertCircle /> : null}
                                                            onClick={() => window.confirm("Are you sure you want to report this transaction?") && reportTransaction(order?.id)}
                                                        >

                                                            {!reportingProof && 'Report'}
                                                            {reportingProof && <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>}

                                                        </Button>
                                                    )}

                                                    {order?.image && order?.image != '' && order?.image != 0 && (
                                                        <Button
                                                            onClick={() => setFocusedPeer(order)}
                                                            variant="outlined"
                                                            startIcon={<Eye />}
                                                            className="border-green-600 text-green-600 hover:bg-green-50"
                                                        >View</Button>
                                                    )}

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <Paper className="p-8 text-center">
                        <Box className="mb-4">
                            <AlertCircle size={48} className="text-gray-400 mx-auto" />
                        </Box>
                        <Typography variant="h6" className="text-gray-700 mb-2">
                            No Orders Found
                        </Typography>
                        <Typography variant="body2" className="text-gray-500">
                            There are no {activeTab === "all" ? "" : activeTab + " "}
                            orders available at the moment.
                        </Typography>
                    </Paper>
                )}
            </div>
        </div>
        <ImagePopup onClose={() => setFocusedPeer(null)} isOpen={focusedPeer} imageUrl={`${guessAdminRoute()}/assets/uploads/p2p/${focusedPeer?.image}`} />
        {/* 
        <ImageViewer
          src={[focusedPeer?.image]}
          currentIndex={ 0 }
          disableScroll={ false }
          closeOnClickOutside={ true }
          onClose={ closeImageViewer }
        /> */}

    </WrapUpP2p>
    );
};

export default P2POrderDisplay;